import { CollectionName } from "@snubes/snubes-types";
import { doc } from "firebase/firestore";
import { db } from "../consts/FIREBASE";

export function getDocRef(collectionName: CollectionName, docId: string) {
  return doc(db, collectionName, docId);
}
